import { request } from '@/utils/request'
const WorkOrder = {
  state: {},

  mutations: {},

  actions: {
    // 工单类型列表
    GetSchemeCodeList({ commit, rootState }, params) {
      return new Promise((resolve, reject) => {
        request.get('/api/WF/v1/GetSchemeCodeList', {
          ProjectIdStr: rootState['projects'].selectProject.IdStr
        }).then(response => {
          resolve(response.Data_Obj)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 在告警处生成工单
    /*
    @params
    WRID: 1107160
    schemeCode: QXGD
    */
    CreateOrderByWarning({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/api/WF/v1/Create',
          params
        ).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 查询工单
    /*
    rows: 10
    page: 1
    queryJson: {"keyword":"","schemeCode":"","ProjectIdStr":"Q0VGOTQ0QTA1QkI4QzlCQw"}
    */
    GetTaskList({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/WorkFlowModule/WfMyTask/GetTaskList',
          params
        ).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    //
    // 查询工单 ===>>> 已办
    /*
    rows: 10
    page: 1
    queryJson: {"keyword":"","schemeCode":"","ProjectIdStr":"Q0VGOTQ0QTA1QkI4QzlCQw"}
    */
    GetDoneTaskList({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/WorkFlowModule/WfDoneTask/GetTaskList',
          params
        ).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询工单 ===>>> 已归档
    /*
    rows: 10
    page: 1
    queryJson: {"keyword":"","schemeCode":"","ProjectIdStr":"Q0VGOTQ0QTA1QkI4QzlCQw"}
    */
    GetFinishProcessList({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/WorkFlowModule/WfFinishProcess/GetFinishProcessList',
          params
        ).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询工单 ===>>> 全部
    /*
    rows: 10
    page: 1
    keyword:
    schemeCode:
    ProjectIdStr: Q0VGOTQ0QTA1QkI4QzlCQw
    */
    GetAllTaskList({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/WorkFlowModule/WfMultSearchTask/GetAllEquipment',
          params
        ).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /*
    ProjectIdStr: MDlCRTQ0MDgzQ0U3NzgyNQ
    isNew: true
    processName: 111
    description: 111
    processLevel: 1
    schemeCode: GD_Default
    processId: f6a77484-af3a-4e1c-8be2-6fd04d7ebf22
    */
    creatTask({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post('/WorkFlowModule/WorkFlow/Create', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    auditTask({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post('/WorkFlowModule/WorkFlow/Audit', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    ProcessinfoByMonitor({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/WorkFlowModule/WorkFlow/ProcessinfoByMonitor',
          params
        ).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
  }
}
export default WorkOrder
